module.exports = __webpack_public_path__ + "media/images/equipments-bg-03-e933d14962680dd82cb5d5a3cd75d8cf.svg";